<template>
  <div class="page-container">
    <!-- <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
      </a-tab-pane>
    </a-tabs> -->
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <!--          <j-dict-select-tag-->
          <!--            style="width: 170px; margin-right: 15px"-->
          <!--            placeholder="请选择年级"-->
          <!--            v-model="queryParam.gradeId"-->
          <!--            identityGet="gradeDict"-->
          <!--            :isShowEmpty="false"-->
          <!--            @select="$set(queryParam, 'classId', undefined)"-->
          <!--          />-->
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            identityGet="classDict"
            :async="true"
            :isShowEmpty="false"
          />
          <a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="关爱等级"
            dictCode="care_list"
            class="search-space"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 200px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <div>
          <a-button
            type="primary"
            icon="download"
            style="margin-right: 15px"
            @click="handleExportXls('家校沟通记录')"
          >
            导出
          </a-button>
          <a-button type="primary" @click="addCommunicatRecord()">添加沟通记录</a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="addCommunicatRecord(record)">编辑</span>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除该条记录吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="deleteItem(record)"
            @cancel="() => {}"
          >
            <span :style="{ color: '#f81d22' }">删除</span>
          </a-popconfirm>
          <a-divider type="vertical" />
          <span @click="addCommunicatRecord(record, 'view')">沟通记录</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <CommunRecordModal ref="communRecordModalRef" @refreshData="loadData" />
    <EffectFeedbackModal ref="effectFeedbackModalRef" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { deleteAction, getAction } from '@api/manage'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import CommunRecordModal from './components/CommunRecordModal'
import EffectFeedbackModal from './components/EffectFeedbackModal'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'HomeSchoolCommun',
  components: {
    TableList,
    AssessModal,
    CommunRecordModal,
    EffectFeedbackModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {
        dateType: 9,
        order: 'desc',
        column: 'createTime',
      },
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '学生咨询',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'classId_dictText',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'studentId_dictText',
              align: 'center',
            },
            {
              title: '沟通时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            {
              title: '问题原因',
              dataIndex: 'tagId',
              align: 'center',
              customRender: (_, record) => {
                return getDictCodeData('emotional_type', record.tagId).text
              },
            },
            {
              title: '详情描述',
              dataIndex: 'comment',
              align: 'center',
              customRender: (_, record) => {
                return record.comment.length > 20 ? (
                  <a-tooltip>
                    <template slot="title">{record.comment}</template>
                    {`${record.comment.slice(0, 20)}...`}
                  </a-tooltip>
                ) : (
                  record.comment
                )
              },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '',
        exportXlsUrl: '/aigoes/schoolWarnRecord/exportXls',
      },
      detailModalData: [],
      disableMixinCreated: true,
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/list')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    addCommunicatRecord(record, type) {
      this.$refs.communRecordModalRef.showModal(record, type)
    },
    async deleteItem(record) {
      const res = await deleteAction('/aigoes/schoolWarnRecord/delete', { id: record.id })
      if (res.success) {
        this.$message.success('删除成功')
        this.loadData()
      } else {
        this.$message.error('删除失败')
      }
    },
  },
}
</script>
<style scoped lang="less">
.page-container {
  .query-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .action-detail {
    min-width: 100px !important;
    color: #0077fa !important;
    cursor: pointer !important;
  }
  .search-space {
    width: 140px;
    margin-right: 15px;
  }
}
</style>
